// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__383W5","logoContainer":"Footer_logoContainer__1FL1w","btnsContainer":"Footer_btnsContainer__1Sg-U","btn":"Footer_btn__2D9l8"};